import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Typography, IconButton,Button} from '@mui/material';
import { Search as SearchIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import axios from 'axios';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL'; 
import AddUserDialog from '../Contents/AdminUser/AddAdminUserDialog';
import { toast } from 'react-toastify';
/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const AdminUsers = () => {

  
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [StudentData,setStudentData] = useState(null)
  const [CountData,setCountData] = useState(0)
  const rowsPerPage = 6;
  const {setLoader,AdministratorTokens,RefreshUesFF} = useContext(ContextData)

  useEffect(()=>{
      

      async function FetchData(){
              //  setLoader(true)  

            try {
              const response = await axios.get(`${baseUrl}/auth/get_admin_users`,{
                withCredentials: true,
                headers: {
                  'Accept' : 'application/json',
                  'authorization': `Bearer ${AdministratorTokens !== null && AdministratorTokens}`
                }}) 

              setCountData(Object.keys(response.data))
              setStudentData(response.data)
              setLoader(false)
             
            } catch (err) {
               if(err) console.log(err.message)
              // setLoader(false)
            }

           
      }FetchData()


  },[RefreshUesFF])

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };


  
    const List =  Object.keys(StudentData !== null && StudentData).map(data=> StudentData[data])
    const filteredUsers = List.filter(user => {
    const lowerCaseSearchText = searchText.toLowerCase().trim();
    return (
     ( user.fname.toLowerCase().includes(lowerCaseSearchText) &&   user.lname.toLowerCase().includes(lowerCaseSearchText) ) ||
      user.mobileNumber.toLowerCase().includes(lowerCaseSearchText) ||
      user.acct_typ.toLowerCase().includes(lowerCaseSearchText) ||
      user.email.toLowerCase().includes(lowerCaseSearchText)
      // Add more fields for search if needed (e.g., state, phone number)
    );
  });

  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const usersToShow = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handleNextPage = () => {
    setCurrentPage(prevPage => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage(prevPage => prevPage - 1);
  };

  const HanldeRemove = async (sttokens) =>{

    
    try {
      const response = await axios.delete(`${""}/auth/delete_student/${sttokens}`,{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${AdministratorTokens !== null && AdministratorTokens}`
        }})
          } catch (err) {

       if(err) console.log(err.message)
      
       }



  }

    const HandleMatrix = async (tokens, matrix_status) =>{

    
    try {
      const response = await axios.put(`${baseUrl}/auth/update_matrix_status_admin_users`,{
         userToken: tokens,
         matrix_status: matrix_status,  
         withCredentials: true,
         headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${AdministratorTokens !== null && AdministratorTokens}`
          }})

            if (response.data.status) {
                toast.success(response.data.message)
            }

            
          } catch (err) {

       if(err) console.log(err.message)
      
       }



  }

  return (
    <div  className="con-dev" style={{width:"100%",height:"100%"}}>
    <Container
    >
      <Typography variant="h4" gutterBottom className='flex justify-between items-center'>
        <p className='font-extrabold mt-3'>Admin Users</p>
        <div>
          <AddUserDialog />
        </div>
      </Typography>
      
      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{background:"rgb(0, 24, 69)"}}>
            <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>No</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Full Name</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Email</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Mobile</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Usertype</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Access Level</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Matrix</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Lock</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Time</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Date</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Remove</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usersToShow.map((user,index) => (
                    
              <TableRow key={user.id}>
                 <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{index + 1}</TableCell>
               {/*  <TableCell>
                  <Avatar sx={{boxShadow:'2px 2px 10px rgba(0,0,0,0.364)'}} alt={user.fname} src={`https://example.com/avatars/${user.id}.png`} />
                </TableCell> */}

                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.fname} {user.lname}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.email}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.mobileNumber}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.acct_typ}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.acc_level}%</TableCell>

                    <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.lock_acc.toString() === "0" ?
                 
                <Button className='Hover-' onClick={()=> HandleMatrix(user.userToken,true)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(55, 12, 221)', margin:'9px 0px'}}  size="large" variant="contained">
                  See Matrix
                 </Button>
                  :
                 <Button className='Hover-' onClick={()=> HandleMatrix(user.userToken,false)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(55, 122, 221)', margin:'9px 0px'}}  size="large" variant="contained">
                  Cancel Matrix
                </Button>
                }
                </TableCell>
              
                  {
                  user.acct_typ === "Administrator"  ? 
                 
                 <TableCell align='center' sx={{whiteSpace:"nowrap"}}>
                 <Button disabled={true} className='Hover-' elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(179, 103, 21)', margin:'9px 0px'}}  size="large" variant="contained">
                  Lock
                </Button>
                </TableCell>
                  :
                  
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.lock_acc.toString() === "0" ?
                 
                <Button className='Hover-' onClick={()=> HanldeRemove(user.st_tokens)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(199, 1, 1)', margin:'9px 0px'}}  size="large" variant="contained">
                   Lock
                 </Button>
                  :
                 <Button className='Hover-' onClick={()=> HanldeRemove(user.st_tokens)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(179, 103, 21)', margin:'9px 0px'}}  size="large" variant="contained">
                  Unlock
                </Button>
                }
                </TableCell>
                      
                  }
               

                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.signupDate.slice(user.signupDate.indexOf("T") + 1)}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.signupDate.slice(0,user.signupDate.indexOf("T"))}</TableCell>
         
                   
                <TableCell>
                   {user.acct_typ === "Administrator" ?
                  
                  <Button disabled={true} className='Hover-' onClick={()=> HanldeRemove(user.st_tokens)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(199, 1, 1)', margin:'9px 0px'}}  size="large" variant="contained">
                  Remove
                   </Button>
                   :
                  <Button className='Hover-' onClick={()=> HanldeRemove(user.st_tokens)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(199, 1, 1)', margin:'9px 0px'}}  size="large" variant="contained">
                   Remove
                 </Button> 
                 
                 }

                 </TableCell> 

                  
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {totalPages > 1 && (
        <div>
          {currentPage > 1 && (
      <Button className='Hover-' onClick={handlePrevPage} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(0, 24, 69)', color:"white", margin:'9px 4px'}}  size="large" variant="contained">
      <ArrowBackIcon />
      </Button>
          )}
          <span>Page {currentPage} of {totalPages}</span>
          {currentPage < totalPages && (
             <Button className='Hover-' onClick={handleNextPage} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(0, 24, 69)', color:"white", margin:'9px 4px'}}  size="large" variant="contained">
                 <ArrowForwardIcon />
           </Button>
            
          )}
          
        </div>
      )}
    </Container>
    </div>
  );
};

export default AdminUsers;


// get_data_adminuser